/* eslint-disable no-restricted-syntax */
import { put, all, takeLatest, call } from 'redux-saga/effects';
import {
  postChat,
  updateChat,
  toggleWidget,
  gptKeyExists,
  minimizeWidget,
  setTempHistory,
  setHistoryObject,
  setSettings,
  closePrebuiltPromptOptions,
} from '../routines/velarisAiRoutines';
import { removeAttributeFromArray } from '../../common/util/velarisAiUtil';
import envConfig from '../../config';
import {
  getValidToken,
  getCurrentTenant,
  request,
} from '../../common/util/RestClient';
import { HTTP_NO_CONTENT_FOUND } from '../../common/constants/CommonConstants';

export function* postChatSaga({ payload }) {
  try {
    const { messages, ...rest } = payload;
    const modifiedMessages = removeAttributeFromArray(messages, 'toDelete');
    const modifiedPayload = { messages: modifiedMessages, ...rest };
    const authToken = yield getValidToken();
    const tenantId = yield getCurrentTenant();
    const response = yield fetch(`${envConfig.BFF_URL}gpt-portal`, {
      method: 'POST',
      headers: {
        Authorization: authToken,
        'Content-Type': 'application/json',
        'Tenant-Id': tenantId,
      },
      body: JSON.stringify(modifiedPayload),
    });

    const reader = response.body.getReader();
    let done = false;
    let message = '';
    let buffer = '';

    do {
      const bulk = yield reader.read();
      done = bulk.done;
      if (!done) {
        const streamObject = new TextDecoder().decode(bulk.value);
        const chunks = streamObject
          .replaceAll(/^data: /gm, '')
          .split('\n')
          .filter((c) => Boolean(c.length) && c !== '[DONE]')
          .map((c) => JSON.parse(c));
        if (chunks) {
          for (const chunk of chunks) {
            const { content } = chunk.choices[0].delta;
            /* eslint-disable no-continue */
            if (!content) continue;
            buffer += content;
            if (buffer.length > 300) {
              message += buffer;
              buffer = '';
              payload.tempMessage = message;
              yield put(updateChat.trigger(payload));
            }
          }
        }
      }
    } while (!done);

    message += buffer;
    payload.extractedContents = message;
    let assistantResponse;
    if (response?.httpStatus === HTTP_NO_CONTENT_FOUND) {
      assistantResponse = response?.httpStatus;
    } else {
      assistantResponse = payload;
    }
    yield put(postChat.success(assistantResponse));
  } catch (error) {
    yield put(postChat.failure({ error }));
  }
}

export function* toggleWidgetSaga({ payload }) {
  try {
    yield put(toggleWidget.success(payload));
  } catch (error) {
    yield put(toggleWidget.failure({ error }));
  }
}

function* gptKeySaga() {
  try {
    const url = `${envConfig.APIG_URL}core/gpt-portal/gpt-key`;
    const response = yield call(request, url);
    const isGptKeyPresent = response.data;
    yield put(gptKeyExists.success(isGptKeyPresent));
  } catch (error) {
    yield put(gptKeyExists.failure({ error }));
  }
}

export function* minimizeWidgetSaga({ payload }) {
  try {
    yield put(minimizeWidget.success(payload));
  } catch (error) {
    yield put(minimizeWidget.failure({ error }));
  }
}

export function* setTempHistorySaga({ payload }) {
  try {
    yield put(setTempHistory.success(payload));
  } catch (error) {
    yield put(setTempHistory.failure({ error }));
  }
}

export function* setHistoryObjectSaga({ payload }) {
  try {
    yield put(setHistoryObject.success(payload));
  } catch (error) {
    yield put(setHistoryObject.failure({ error }));
  }
}

export function* setSettingsSaga({ payload }) {
  try {
    yield put(setSettings.success(payload));
  } catch (error) {
    yield put(setSettings.failure({ error }));
  }
}

export function* closePrebuiltPromptOptionsSaga({ payload }) {
  try {
    yield put(closePrebuiltPromptOptions.success(payload));
  } catch (error) {
    yield put(closePrebuiltPromptOptions.failure({ error }));
  }
}

export default function* root() {
  yield all([
    takeLatest(postChat.TRIGGER, postChatSaga),
    takeLatest(toggleWidget.TRIGGER, toggleWidgetSaga),
    takeLatest(gptKeyExists.TRIGGER, gptKeySaga),
    takeLatest(minimizeWidget.TRIGGER, minimizeWidgetSaga),
    takeLatest(setTempHistory.TRIGGER, setTempHistorySaga),
    takeLatest(setHistoryObject.TRIGGER, setHistoryObjectSaga),
    takeLatest(setSettings.TRIGGER, setSettingsSaga),
    takeLatest(
      closePrebuiltPromptOptions.TRIGGER,
      closePrebuiltPromptOptionsSaga
    ),
  ]);
}
